export const isFunction = (obj: any): obj is (...args: any[]) => any => typeof obj === 'function';
